import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';


@Component({
  selector: 'nym-wallet-activity-listing-no-results',
  templateUrl: './wallet-activity-listing-no-results.component.html',
  styleUrls: ['./wallet-activity-listing-no-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletActivityListingNoResultsComponent implements OnInit {

  @HostBinding('class.nym-wallet-activity-listing-no-results')
  protected get classes(): boolean { return true; }

  constructor() { }

  public ngOnInit(): void { }

}
